/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

const FileHandle = require('./FileHandle.js');

class ImportantFilesProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		/** @type {import('fable')} */
		this.fable;

		/** @type {any} */
		this.options;

		this.fable.serviceManager.addServiceType('HeadlightRestClient', require(`headlight-rest-client`));

		if (!this.options.hasOwnProperty('HeadlightAPIURL'))
		{
			this.options.HeadlightAPIURL = '/1.0/';
		}
		this.fable.serviceManager.instantiateServiceProviderIfNotExists('HeadlightRestClient', { ServerURL: this.options.HeadlightAPIURL });
	}

	/**
	 * Perform a JSON GET request.
	 *
	 * @param {string} uri - The URI to get.
	 * @return {Promise<any>} - The response.
	 */
	async _get(uri)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getJSON(uri, (pError, pBody) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * @param {string|number} pIDProject - The project ID.
	 * @param {string} pPath - The path to the directory to list.
	 * @return {Promise<FileHandle[]>}
	 */
	async listFiles(pIDProject, pPath = '/')
	{
		const files = await this._get(`ImportantProjectFiles/${pIDProject}${pPath}`);
		const result = [];
		for (const folder of files.Folders)
		{
			result.push(new FileHandle({ Name: folder.Name, IsFolder: true, Path: `${pPath}/${folder.Name}` }));
		}
		for (const file of files.Files)
		{
			//TODO: populate the file type, etc. - can we tell from the observation? maybe the artifact datum?
			//FIXME: populate `Parent` when we start populating that as part of the artifact extraction adventure
			//       probably create a factory or something so we can centralize building this for file handles
			result.push(new FileHandle({ Name: file.Name, Path: `${pPath}/${file.Name}`, IsFolder: false, Observation: file.Observation }));
		}
		return result;
	}

	/**
	 * @param {FileHandle} pFileHandle - The file to get the URL for.
	 * @return {string} - The URI.
	 */
	getDownloadURI(pFileHandle)
	{
		if (!pFileHandle.observation)
		{
			throw new Error(`Cannot provide a URL for a file that isn't an observation.`);
		}
		return `/1.0/ImportantProjectFile/${pFileHandle.observation.IDProject}/${pFileHandle.path}`;
	}
}

module.exports = ImportantFilesProvider;
module.exports.default_configuration = {};
